import styled from 'styled-components';
import DispatchingFilters from './component';

export default styled(DispatchingFilters)``;
